import React from "react";
import Navbar from "../Navbar";
import WelcomeBanner from "./WelcomeBanner";
import WidgetCard from "./WidgetCard";
import Config from "../../Config";
import { UserAuth } from "../../context/AuthContext";
import "./home.css";

const HomePage = () => {
  const { user } = UserAuth();

  const OPTIONS = [
    {
      id: 1,
      text: "Document Work Items",
      icon: "/document-exception-svg.svg",
      path: Config.TicketExternalLink || "/manage-ticket",
      bg: "bg-gradient-to-r from-green-200 to-green-300",
      desc: "Review and Resolve Document Work Items",
    },
    {
      id: 2,
      text: "Analytics Dashboard",
      icon: "/analytics-svg.svg",
      path: Config.AnalyticsExternalLink,
      bg: "bg-gradient-to-r from-blue-200 to-blue-300",
      desc: "Review Analytics",
      external: true,
    },
    ...(user?.isAdmin
      ? [
          {
            id: 3,
            text: "Admin Access Controls",
            icon: "/admin.svg",
            path: Config.TicketExternalLink || "/admin/users",
            bg: "bg-gradient-to-r from-purple-200 to-purple-300",
            desc: "Manage Users and Admin Settings",
            external: false,
          },
        ]
      : []),
  ];

  return (
    <div className="home-page">
      <Navbar />
      <WelcomeBanner />
      <main className="home-main">
        {OPTIONS.length > 0 ? (
          <div className="home-options-grid">
            {OPTIONS.map((option) => (
              <div key={option.id} className="widget-card">
                <WidgetCard {...option} />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center">
            <p className="text-gray-500 text-xl">No widgets available.</p>
          </div>
        )}
      </main>
      <footer
        className="footer-height bg-gray-200 text-center text-sm py-2"
        style={{
          marginTop: "auto",
          height: "2rem",
          lineHeight: "2rem",
          backgroundColor: "var(--white-2)",
        }}
      >
      </footer>
    </div>
  );
};

export default HomePage;
